import { KYMW2400Model } from '../kymw2400.model';
import { SectionTemplateModel } from '../vo/section-template.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * セクション選択コマンド。
 * 管理クラスに選択されたセクションのIDを渡し、セクションの情報を取り出してもらう。
 *
 * @export SelectSectionService
 * @class SelectSectionService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class SelectSectionService {

  private model: KYMW2400Model = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
  }

  /**
   * セクション選択処理
   *
   * @param {KYMW2400Model} model モデルクラス
   * @param {SectionTemplateModel} vo
   * @memberof SelectSectionService
   */
  execute(model: KYMW2400Model, vo: SectionTemplateModel) {
    this.model = model;
    this.model.changeSelectedSection(vo);
  }
}
